import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../app.settings';
import { BreadcrumbsComp } from '../../../Components/BreadcrumbsComp';
import { ButtonComp } from '../../../Components/ButtonComp';
import FilterTextComp from '../../../Components/FilterTextComp';
import LoadingPageComp from '../../../Components/LoadingPageComp';
import { useLotacao } from './context';
import { Table } from 'flowbite-react';
import NoResultsPNG from '../../../assets/png/no-results.png';
import Highlighter from 'react-highlight-words';

export default function LotacaoList() {
  const navigate = useNavigate();
  const { loading, list, setCurrent, filter, setFilter } = useLotacao();

  return (
    <>
      <div className="flex items-center justify-between py-3">
        <BreadcrumbsComp title="Lotação" paths={[]} />
        <div className="flex space-x-2 items-center">
          <FilterTextComp value={filter || ''} onChange={setFilter} />
          <ButtonComp label="Inserir" type="button" onClick={() => navigate(PATHS.lotacaoInsert)} />
        </div>
      </div>
      <div className="flex items-center justify-end pb-3">
        {/* <FilterTextComp value={filter} onChange={setFilter} /> */}
      </div>
      <div className="hidden md:block">
        {loading ? (
          <LoadingPageComp />
        ) : (
          <Table hoverable={true}>
            {list.length === 0 ? (
              <div className="w-full">
                <img className="mx-auto grayscale-0 opacity-50" src={NoResultsPNG} alt="" />
              </div>
            ) : (
              <>
                <Table.Head>
                  <Table.HeadCell className="grow">Comarca</Table.HeadCell>
                  <Table.HeadCell className="grow">Local</Table.HeadCell>
                  <Table.HeadCell className="grow">Cidade</Table.HeadCell>
                </Table.Head>

                <Table.Body className="divide-y">
                  {list.map((el) => (
                    <Table.Row
                      key={el.id}
                      className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer"
                      onClick={async () => {
                        setCurrent(el);
                        await new Promise((t) => setTimeout(t, 300));
                        navigate(PATHS.lotacaoEdit(el.id.toString()));
                      }}
                    >
                      <Table.Cell className="font-medium text-gray-900 dark:text-white">
                        <span>
                          {filter ? (
                            <Highlighter searchWords={[filter]} textToHighlight={el.comarca} />
                          ) : (
                            <span>{el.comarca}</span>
                          )}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="font-medium text-gray-900 dark:text-white">
                        <span>
                          {filter ? (
                            <Highlighter searchWords={[filter]} textToHighlight={el.local} />
                          ) : (
                            <span>{el.local}</span>
                          )}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="font-medium text-gray-900 dark:text-white">
                        {filter ? (
                          <Highlighter
                            searchWords={[filter]}
                            textToHighlight={el?.municipio?.nome}
                          />
                        ) : (
                          <span>{el?.municipio?.nome}</span>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </>
            )}
          </Table>
        )}
      </div>
    </>
  );
}
